export const addItemsToCart = (cartItems, itemToAdd) => {
    const existingCartItems = cartItems.find(cartItem => cartItem.id === itemToAdd.id);

    if (existingCartItems) {
        return cartItems.map(cartItem => cartItem.id === itemToAdd.id ? {...cartItem, quantity: cartItem.quantity + 1 } : cartItem);
    }

    return [...cartItems, {...itemToAdd, quantity: 1 }]
}

export const decreaseCartItems = (cartItems, itemToDecrease) => {
    const existingCartItem = cartItems.find(cartItem => cartItem.id === itemToDecrease.id);

    if (existingCartItem.quantity === 1) {
        return cartItems.filter(cartItem => cartItem.id !== itemToDecrease.id)
    }

    return cartItems.map(cartItem => cartItem.id === itemToDecrease.id ? {...cartItem, quantity: cartItem.quantity - 1 } : cartItem)
}